import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	unAuthPluginStatus: {
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[100])
	},
	authPluginStatus: {
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600])
	},
	authPluginButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[100]),
		border: "1px solid",
		boxShadow: "none",
		borderColor: "rgba(126, 13, 214, 0.12)",
		fontWeight: 500,
		fontSize: "16px",
		color: colors.getPrimaryColor(),
		letterSpacing: 0.4,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[300]),
			boxShadow: "none"
		}
	}
})

export default useStyles
